export default "__VITE_ASSET__BP9mdNOV__"